/* @flow */

import { errorColor } from '@e180/ui/lib/token/color';
import { blueGrey, aaDarkGrey, black, white } from '@e180/ui/lib/token/palette';
import { highlightedInputFontFamily } from '@e180/ui/lib/token/typography';

export default {
  root: {
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    color: ({ accentColor }: Object) => accentColor,

    WebkitFontSmoothing: 'antialiased',
  },
  input: {
    background: 'none',

    WebkitFontSmoothing: 'antialiased',

    '&:focus': {
      borderColor: ({ accentColor }: Object) => accentColor,
    },

    '&::placeholder': {
      color: aaDarkGrey,

      WebkitFontSmoothing: 'antialiased',
    },
  },
  'input-isHighlighted': {
    padding: '0.5em',

    backgroundColor: white,
    borderRadius: 4,
    border: 'none',
    color: black,

    fontFamily: highlightedInputFontFamily,
    fontSize: 22,
    lineHeight: 1.1,

    '&::placeholder': {
      color: '#747476',

      fontStyle: 'normal',
      WebkitFontSmoothing: 'antialiased',
    },
  },
  'input-onLightBg': {
    border: `solid 1px ${aaDarkGrey}`,
    color: `${blueGrey} !important`,

    '&:focus': {
      borderLeftColor: `${aaDarkGrey} !important`,
      borderTopColor: `${aaDarkGrey} !important`,
      borderRightColor: `${aaDarkGrey} !important`,
      borderBottomWidth: 2,
    },
  },
  'input-isInvalid': {
    borderColor: `${errorColor} !important`,
  },
  'input-noBorder': {
    borderColor: 'rgb(0, 0, 0, 0)',
  },
  'input-isDarkText': {
    color: `${blueGrey} !important`,
  },
  error: {
    position: 'absolute',
    top: '100%',

    padding: '0.25em 0',

    color: errorColor,

    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: 500,
    WebkitFontSmoothing: 'antialiased',
  },
  maxLengthCtn: {
    position: 'absolute',
    top: '100%',
    right: 0,
  },
  helper: {
    display: 'block',

    marginTop: 4,

    color: aaDarkGrey,

    fontSize: 12,
    fontStyle: 'italic',
    textAlign: 'right',
    WebkitFontSmoothing: 'antialiased',
  },
};
